import Factory from '../factory';

const schema = Factory.schema('show-more');
const attributes = schema.getProp('attributes').getValue();

attributes.prop('text').setType(String).setValue('<p>&nbsp;</p>');

export default schema;
